import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.RENEWAL_INTERCOM_NOTIFICATION_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.RENEWAL_INTERCOM_NOTIFICATION_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const renewalIntercomNotification = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.RENEWAL_INTERCOM_NOTIFICATION_REQUEST });

    axios.post('/subscriptions/renewal-intercom', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
